// Single source of truth for account-type logic.
// Use these helpers everywhere instead of hardcoding string comparisons,
// so adding new account types only requires changing this file.

export const isExecLike  = (t) => t === 'music_executive' || t === 'organization';
export const isComposer  = (t) => t === 'composer';
export const isAdmin     = (t) => t === 'admin';
export const isOrg       = (t) => t === 'organization';

export const accountLabel = (t) => {
  if (t === 'admin')           return 'Founder';
  if (t === 'organization')    return 'Organization';
  if (t === 'music_executive') return 'Music Executive';
  return 'Composer';
};
